import { render, staticRenderFns } from "./pwaInstallBtn.vue?vue&type=template&id=61810440&scoped=true&"
import script from "./pwaInstallBtn.vue?vue&type=script&lang=js&"
export * from "./pwaInstallBtn.vue?vue&type=script&lang=js&"
import style0 from "./pwaInstallBtn.vue?vue&type=style&index=0&id=61810440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61810440",
  null
  
)

export default component.exports